// Module
var code = "<div name=commentDetailsModal class=comment-details-modal> <div ng-if=\"isPngFile || isGifFile || isJpegFile\"> <img id=image ng-src={{objectModal}}> </div> </div>";
// Exports
module.exports = code;